/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setGenerateTermFilter } from "../index";

export const useGenerateTermFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter: any = ({ key, value }: { key: string; value: any }) => {
    dispatch(setGenerateTermFilter({ key, value }));
  };

  return { updateFilter };
};